import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class WM2000PWMLEDNode extends BaseNode {
    constructor() {
        super();
        this.name = 'WM2000 PWM LED';
        this.id = 'node_wm2000ev_led';
        this.linkedFeature = 'wm2000ev_pwm_led';
        this.requirements = ['WM2000EV'];

        const port = new NodePort();
        port.initSettings();
        port.setSettingValue('NAME', 'Set LED');
        port.setSettingValue('PORTID', 'wm2000ev_led_set');
        this.inputs = [
            {
                name: 'Set LED',
                portId: 'wm2000ev_led_set',
                params: [
                    {
                        name: 'red',
                        dataType: TibboDataType.BYTE,
                        default: '0',
                    },
                    {
                        name: 'green',
                        dataType: TibboDataType.BYTE,
                        default: '0',
                    },
                    {
                        name: 'blue',
                        dataType: TibboDataType.BYTE,
                        default: '0',
                    },
                ],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;

        const links = project.getNodeLinks(this, 'wm2000ev_led_set');
        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            blocks.push({
                location: link.getSourceId(),
                id: 'declare_EV_LIGHT_read',
                blockType: BlockType.CODE,
                template: `
    WM2000EV_set_led(${project.getNodeParameter(link, 'red')},${project.getNodeParameter(link, 'green')},${project.getNodeParameter(link, 'blue')})`,
            });
        }

        return blocks;
    }
}
